var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.536 9A.536.536 0 0 0 1 9.536v3.643c0 .294.24.534.536.534h3.643c.294 0 .534-.24.534-.535V9.535A.536.536 0 0 0 5.18 9H1.535zm5.357 5.25a.536.536 0 0 0-.536.536v8.357c0 .296.24.536.536.536h3.643c.296-.001.535-.241.535-.537v-8.357a.536.536 0 0 0-.534-.536H6.893zm4.286-4.714c-.001-.296.238-.536.534-.536h3.643c.296 0 .536.24.536.536v3.2l1.647 1.514h3.174c.296 0 .536.24.536.536v8.357c0 .296-.24.536-.536.536h-3.643a.536.536 0 0 1-.534-.537v-8.268l-1.266-1.16h-3.556a.536.536 0 0 1-.535-.536V9.535zM21.463 9a.536.536 0 0 0-.535.536v3.643c-.001.294.238.534.534.534h3.556l1.266 1.16v8.269c0 .296.24.536.535.536h3.644c.296-.001.536-.241.536-.537v-8.357a.536.536 0 0 0-.536-.536H27.29l-1.647-1.515v-3.2A.536.536 0 0 0 25.107 9h-3.643z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/META.31fb124e7216b8cf5da9d2fc37aa8824.svg";
export { ForwardRef as ReactComponent };